"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useExpandableOfferItemsLists = void 0;
var _mui = require("@ori-ui/mui");
var _react = require("react");
var _logger = require("../logger");
const DEFAULT_VISIBLE_ITEMS_COUNT = 8;
const useExpandableOfferItemsLists = ({
  items1stSection,
  items2ndSection
}) => {
  const [visibleItemsCount1stSection, setVisibleItemsCount1stSection] = (0, _react.useState)(DEFAULT_VISIBLE_ITEMS_COUNT);
  const [visibleItemsCount2ndSection, setVisibleItemsCount2ndSection] = (0, _react.useState)(DEFAULT_VISIBLE_ITEMS_COUNT);
  const itemsCount1stSection = (0, _react.useMemo)(() => items1stSection.length, [items1stSection]);
  const shouldShowSeeAllBanner1stSection = (0, _react.useMemo)(() => itemsCount1stSection > visibleItemsCount1stSection, [itemsCount1stSection, visibleItemsCount1stSection]);
  const seeAllItems1stSectionHandler = (0, _react.useCallback)(() => {
    setVisibleItemsCount1stSection(itemsCount1stSection);
  }, [setVisibleItemsCount1stSection, itemsCount1stSection]);
  const itemsCount2ndSection = (0, _react.useMemo)(() => items2ndSection.length, [items2ndSection]);
  const shouldShowSeeAllBanner2ndSection = (0, _react.useMemo)(() => itemsCount2ndSection > visibleItemsCount2ndSection, [itemsCount2ndSection, visibleItemsCount2ndSection]);
  const seeAllItems2ndSectionHandler = (0, _react.useCallback)(() => {
    (0, _logger.logDebug)('seeAllItems2ndSectionHandler(), itemsCount2ndSection', itemsCount2ndSection, 'items2ndSection', items2ndSection);
    setVisibleItemsCount2ndSection(itemsCount2ndSection);
  }, [itemsCount2ndSection, items2ndSection]);
  const isScreenMedium = (0, _mui.useMediaQuery)(theme => theme.breakpoints.up('md'));
  const isScreenSmall = (0, _mui.useMediaQuery)(theme => theme.breakpoints.up('sm'));
  const getItemsEligibleForExpandAll = (0, _react.useCallback)(() => {
    if (isScreenMedium) {
      return 4;
    } else if (isScreenSmall) {
      return 3;
    }
    return 2;
  }, [isScreenMedium, isScreenSmall]);
  const triggerSeeAllItems2ndSectionAction = (0, _react.useCallback)((itemsCount, index) => {
    const count = getItemsEligibleForExpandAll();
    // If mod returns 0 use eligible items
    const itemsOnLastRow = itemsCount % count || count;
    if (index >= itemsCount - itemsOnLastRow) {
      seeAllItems2ndSectionHandler();
    }
  }, [getItemsEligibleForExpandAll, seeAllItems2ndSectionHandler]);
  return {
    getItemsEligibleForExpandAll,
    itemsCount1stSection,
    itemsCount2ndSection,
    seeAllItems1stSectionHandler,
    seeAllItems2ndSectionHandler,
    shouldShowSeeAllBanner1stSection,
    shouldShowSeeAllBanner2ndSection,
    triggerSeeAllItems2ndSectionAction,
    visibleItemsCount1stSection,
    visibleItemsCount2ndSection
  };
};
exports.useExpandableOfferItemsLists = useExpandableOfferItemsLists;